// import Vue from 'vue';

import '../../styles/marketing/main.scss';

import api from 'api';

import util from 'common/util';
import Alert from 'common/Alert';

import Checkbox from 'components/Checkbox';

// Register service worker
navigator.serviceWorker.register( '/sw.min.js', {scope:'/'} ).then( ( swRegistration ) => {
  
  swRegistration.addEventListener( 'updatefound', () => {
    
    var newServiceWorker = swRegistration.installing;

    newServiceWorker.addEventListener( 'statechange', () => {

      // Has service worker state changed?
      switch( newServiceWorker.state ){
        
        case 'installed':
        
          if( navigator.serviceWorker.controller ) {
            newServiceWorker.postMessage({ action: 'skipWaiting' });
          }
          
          break;
          
      }
      
    });
    
  });
  
});

const Login = {
  
  name: 'Login',
  
  props: {
    webauthn_url: String
  },
  
  components: {
    Checkbox
  },
  
  data: function(){
    
    return {
      showTouchLogin: localStorage.getItem('webauthn_rawId') !== null,
      disableInputs: false
    };
    
  },
  
  computed: {
    
    canTouchLogin: function(){
      return this.webauthn_rawId !== null;
    },
    
    webauthn_rawId: function(){
      return localStorage.getItem('webauthn_rawId');
    }
    
  },
  
  methods: {
    
    doTouchLogin: function(){
      
      this.disableInputs = true;
      
      api.getWebAuthnChallenge().then( response => {
        
        var abortController = new AbortController();
        
        abortController.signal.addEventListener( 'abort', () => {
          
          Alert('aborted...');
          
        });
        
        var getCredentialOptions = {
          publicKey: {
            rpid: this.webauthn_url,
            // Cryptographic challenge from the server
            challenge: util.convertBase64ToBinary( response.challenge ), 
            // Timeout after 1 minute
            timeout: 60000,
            userVerification: 'preferred',
            allowCredentials: [{
              id: util.convertBase64ToBinary( this.webauthn_rawId ),
              type: 'public-key',
              transports: ["internal"]
            }]
          },
          signal: abortController.signal
        };
                
        navigator.credentials.get( getCredentialOptions ).then( assertion => {
          
          // Get Base64 version of the rawId
          var rawId = btoa( String.fromCharCode.apply( null, new Uint8Array( assertion.rawId ) ) );
          // Get authenticator binary data as array buffer
          var authenticatorData = new Uint8Array( assertion.response.authenticatorData );
          // Get client binary data as array buffer
          var clientDataJSON = new Uint8Array( assertion.response.clientDataJSON );
          // Get signature binary data as array buffer
          var signature = new Uint8Array( assertion.response.signature );
            
          api.verifyWebAuthnChallenge({
            data: {
              rawId: rawId,
              authenticatorData: authenticatorData,
              clientDataJSON: clientDataJSON,
              signature: signature
            }
          }).then( response => {
            
            var searchParams = new URLSearchParams( window.location.search );
            window.location.href = searchParams.has('redirect') ? ( '/' + searchParams.get('redirect') ) : '/';
            
          }).catch( error => {
            
            alert( error );
            alert( JSON.stringify( error ) );
      
            this.disableInputs = false;
            
          });
        
        }).catch( error => {
          
          switch( error.name ){
            
            case 'NotAllowedError':
              
              alert('Sorry, fingerprint login is not allowed on this device.');
              
              break;
            
            default:
              
              alert( error.name );
              
              break;
          
          }
      
          this.disableInputs = false;
          
          
        });
        
      }).catch( error => {
        
        alert( JSON.stringify( error ) );
      
        this.disableInputs = false;
        
      });
      
    }
    
  },
  
  mounted: function(){
    
    this.$refs.email.focus();
    
  }
  
};

const Signup = {
  
  name: 'Signup',
  
  components: {
    Checkbox
  },
  
  data: function(){
    
    return {
      tierid: null
    };
    
  },
  
  mounted: function(){
    
    this.$refs.timezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    this.$refs.name.focus();
    
  },
  
  methods: {
    
    submitForm: function( e ){
            
      var validated = true;
      $( 'input[data-required],textarea[data-required]', e.target ).each(function( i, v ){
        
        if( $(this).attr('type') == 'checkbox' && !$(this).is(':checked') ){
          
          /*
          $(this).closest('.field').addClass('error');
          
          if( validated ){
            $(this).focus();
            validated = false;
          }
          
          $(this).one( 'click', function(){
            $(this).closest('.field').removeClass('error');
          });
          */
          
        }else if( $(this).val().length === 0 ){
          
          $(this).closest('.field').addClass('error');
          
          if( validated ){
            $(this).focus();
            validated = false;
          }
          
          $(this).one( 'keyup', function(){
            $(this).closest('.field').removeClass('error');
          });
          
        }
        
      });
      
      if( !validated ){
        e.preventDefault();
      }
      
      var $tos = $('input[name="agreetos"]');
      
      if( !$tos.is(':checked') ){
        $tos.focus();
        alert('You must accept the Terms of Service before signing up.');
        return false;
      }
      
      var $password = $( this.$refs.password );
      var $password2 = $( this.$refs.password2 );
      
      if( $password.val() != $password2.val() ){
        $password2.closest('.field').addClass('error nomatch');
        e.preventDefault();
      }
      
      if( !validated ){
        e.preventDefault();
      }                    
                
      return true;
      
    }
    
  }
  
};

export default new Vue({
  
  name: 'Marketing',
  
  el: '#marketing',
  
  components: {
    Checkbox,
    Login,
    Signup
  },
  
  data: function(){
    
    return {
      loaded: new Date(),
      now: new Date()
    };
    
  },
  
  computed: {
    
    duration: function(){
          
      var diff = this.now.getTime() - this.loaded.getTime();
            
      var seconds = Math.floor( diff / 1000 );
      var minutes = Math.floor( seconds / 60 );
      var hours = Math.floor( minutes / 60 );
      
      hours = hours % 24;
      minutes = minutes % 60;
      seconds = seconds % 60;
                          
      return ( hours + ':' ) + ( this.pad( minutes ) + ':' ) + this.pad( seconds );
      
    }
    
  },
  
  methods: {
    
    pad: function( num ){
      return num >= 10 ? num : ( '0' + num )
    }
    
  },
  
  mounted: function(){
    
    setInterval( () => {
      this.now = new Date();
    }, 1000 );
    
  }
  
});